import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NotificationService, Url, Utilities } from 'src/app/common';
import { User, UserAuth } from 'src/app/common/user-auth';
import { ConfirmDialogService } from '../services/confirm-dialog.component';
import { LayoutService } from '../services/layout.service';
import { Deputy } from '../models/deputy';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-notification-deputy',
  templateUrl: '../views/deputy.component.html',
  styleUrls: ['../styles/style.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DebutyComponent implements OnInit {
  userAuth: User = UserAuth.get();
  url = Url;
  @Output() public formClosed: EventEmitter<any> = new EventEmitter();
  deputy: Deputy;
  employees = [];
  substituteEmployees = [];
  id: number = null;
  permisions = {
    READ_TIME_MANAGEMENT_DEPUTY: this.userAuth.getAction(
      'READ_TIME_MANAGEMENT_DEPUTY'
    ),
  };
  constructor(
    public layoutService: LayoutService,
    public confirmDialogService: ConfirmDialogService,
    private notificationService: NotificationService,
    private _router: Router,
  ) {}

  ngOnInit() {
    if(!this.permisions.READ_TIME_MANAGEMENT_DEPUTY) this._router.navigate(['/home'])
    if(this.userAuth.isExternal === false)
     this.getChildrenEmployees();

    this.getAllEmployees();
    this.deputy = new Deputy();
    if (this.id) this.getDeputyById();
  }

  getChildrenEmployees() {
    this.layoutService.getChildrenEmployees(this.userAuth.id).subscribe((response) => {
      if (response.Status == 200) {
        this.employees = response.Employees;
      }
    });
  }

  getAllEmployees() {
    this.layoutService.getAllEmployees().subscribe((response) => {
      if (response.Status == 200) {
        this.substituteEmployees = response.Employees;

        if(this.userAuth.isExternal)
         this.employees = response.Employees;
      }
    });
  }

  getDeputyById() {
    this.layoutService.getDeputy(this.id).subscribe((response) => {
      if (response.Status == 200) {
        this.deputy = {
          id: response.Deputy.id,
          empId: { id: response.Deputy.empId },
          substituteId: { id: response.Deputy.substituteId },
          startDate: Utilities.parseToDate(response.Deputy.startDate),
          endDate: Utilities.parseToDate(response.Deputy.endDate),
        };
      }
    });
  }

  deleteDeputy() {
    this.confirmDialogService.open().subscribe((result) => {
      if (result == 'confirm') {
        this.layoutService.deleteDeputy(this.id).subscribe((response) => {
          if (response.Status == 200) {
            this.formClosed.next({});
          }
        });
      }
    });
  }

  saveDeputy() {
    var deputyDto: any = Object.assign({}, this.deputy);

    this.layoutService
      .saveDeputy(Utilities.getFormatedObject(deputyDto))
      .subscribe((response) => {
        console.log(response);
        if (response.Status == 200) {
          this.notificationService.showSuccess('Successfully saved deputy');
          this.formClosed.next({});
        }
      });
  }

  closeDialog() {
    this.formClosed.next({});
  }
}
